import React from 'react';
import autoBind from 'react-autobind';
import Localization from "../Localization.jsx";
import { Modal, Stack, Box, Text, TextInput, Button, Group } from '@mantine/core';
import { LabelWithInfo } from "./LabelWithInfo.jsx";

class ProfielDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    this.state = {
      displayName: "",
      email: "",
      lastLoginTime: "",
      schoolName: "",
      role: null,
    };
    autoBind(this);

    if (this.props.root.refs.userDataProfile && this.props.root.refs.userDataProfile.state) {
      const userInfo = this.props.root.refs.userDataProfile.state.userInfo || {};
      const schoolInfo = this.props.root.refs.userDataProfile.state.schoolInfo || {};
      this.state.displayName = userInfo.display_name || "";
      this.state.email = userInfo.email || "";
      this.state.lastLoginTime = userInfo.last_login_time || "";
      this.state.role = userInfo.role ?? null;
      this.state.schoolName = (Localization.strings.getLanguage() === "en"
        ? schoolInfo.name_eng
        : schoolInfo.name) || "";
    }
  }

  componentDidUpdate(prevProps) {
    // This dialog stays mounted (visibility is controlled by the `open` prop), so the
    // constructor only captures profile fields once — possibly before userDataProfile has
    // loaded, or before a profile update. Re-sync from the live profile each time it opens.
    if (this.props.open && !prevProps.open) {
      this.loadProfileFromUserData();
    }
  }

  loadProfileFromUserData() {
    const udp = this.props.root.refs.userDataProfile;
    if (!udp || !udp.state) { return; }
    const userInfo = udp.state.userInfo || {};
    const schoolInfo = udp.state.schoolInfo || {};
    this.setState({
      displayName: userInfo.display_name || "",
      email: userInfo.email || "",
      lastLoginTime: userInfo.last_login_time || "",
      role: userInfo.role ?? null,
      schoolName: (Localization.strings.getLanguage() === "en"
        ? schoolInfo.name_eng
        : schoolInfo.name) || "",
    });
  }

  updateProfile = () => {
    if (this.validateInput()) {
      let requestObj = {
        table: "user",
        where_field: "id",
        where_value: this.props.root.getMyUserId(),
        row: {
          display_name: this.state.displayName,
          email: this.state.email,
        },
      };
      this.props.root.refs.API.request("update", requestObj, this.updateProfileOK, this.updateProfileFail);
    }
  };

  updateProfileOK = (res) => {
    console.log("update profile ok");
    this.props.onClose();  // Use onClose passed from the parent to close the dialog
    this.props.root.addNotification(Localization.strings.UPDATED, true);
  };

  updateProfileFail = (err) => {
    console.log("update profile fail " + err);
    this.props.root.addNotification(Localization.strings.UPDATE_FAILED, false);
  };

  displayNameChanged = (event) => {
    this.setState({ displayName: event.target.value });
  };

  emailChanged = (event) => {
    this.setState({ email: event.target.value });
  };

  validateInput = () => {
    let result = true;
    let requirement = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let email = this.state.email.trim();
    let emailOK = email.length > 0 ? requirement.test(email) : true;

    if (this.state.displayName.trim() === "") {
      result = false;
      this.props.root.addNotification(Localization.strings.DISPLAY_NAME_BLANK_REMINDER, false);
    } else if (!emailOK) {
      result = false;
      this.props.root.addNotification(Localization.strings.EMAIL_INCORRECT_REMINDER, false);
    }
    return result;
  };

  getRoleLabel(role) {
    switch (Number(role)) {
      case 0:
        return Localization.strings.USER_ROLE_TEACHER_LOW || 'Teacher (Low privilege)';
      case 1:
        return Localization.strings.USER_ROLE_TEACHER_STANDARD || 'Teacher (Standard)';
      case 2:
        return Localization.strings.USER_ROLE_ADMINISTRATOR || 'Administrator';
      case 3:
        return Localization.strings.PLATFORM_ADMIN_ROLE || 'CLST Administrator';
      default:
        return Localization.strings.USER_ROLE_UNKNOWN || 'Unknown';
    }
  }

  render() {
    const { open, onClose } = this.props;  // Accept open and onClose as props

    return (
      <Modal
        opened={open}
        onClose={onClose}
        title={<Text fw={600}>{Localization.strings.USER_INFORMATION}</Text>}
        size="md"
        centered
        zIndex={2000}
      >
        <Stack gap="md">
          <Box>
            <Text size="sm" c="dimmed">{Localization.strings.SCHOOL_NAME}</Text>
            <Text>{this.state.schoolName}</Text>
          </Box>
          <Box>
            <Text size="sm" c="dimmed">{Localization.strings.USER_ROLE || 'Role'}</Text>
            <Text>
              {this.getRoleLabel(this.state.role)}
              {this.state.role !== null && this.state.role !== undefined ? ` (${this.state.role})` : ''}
            </Text>
          </Box>
          <Box>
            <Text size="sm" c="dimmed">{Localization.strings.LAST_LOGIN_TIME}</Text>
            <Text>{this.state.lastLoginTime}</Text>
          </Box>
          <TextInput
            label={<LabelWithInfo label={Localization.strings.DISPLAY_NAME} info={Localization.strings.DISPLAY_NAME_FOR_LOCALE} />}
            value={this.state.displayName}
            onChange={this.displayNameChanged}
          />
          <TextInput
            label={<LabelWithInfo label={Localization.strings.EMAIL} info={Localization.strings.EMAIL_CAN_BE_USED_AS_LOGIN} />}
            value={this.state.email}
            onChange={this.emailChanged}
          />
          <Group justify="flex-end" mt="sm">
            <Button variant="default" onClick={onClose}>
              {Localization.strings.CANCEL}
            </Button>
            <Button onClick={this.updateProfile}>
              {Localization.strings.UPDATE_PROFILE}
            </Button>
          </Group>
        </Stack>
      </Modal>
    );
  }
}

export default ProfielDialog;
